import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const ClearAlarmGlyph = /*#__PURE__*/createElement("g", {
  id: "clear_alarm"
}, /*#__PURE__*/createElement("path", {
  d: "M69.3,55c-1.1-0.4-2-0.9-3-1.5h-4.8c1.7,1.8,3.8,3.2,6.2,4.2v2.9c0,0.1-0.1,0.1-0.2,0.1H16.3c-0.1,0-0.1,0-0.1-0.1v-2.9 c0,0,0-0.1,0.1-0.1C22.7,55,27,49,27.2,42.2c0.3-4.7,0.5-9.5,0.8-14.2c0.2-2.6,2.4-4.7,5-4.7h5.4h7h5.4c2.2,0,4,1.4,4.7,3.3h3.2 c-0.8-3.6-4-6.3-7.7-6.3h-2.4v-3.5c0-3.6-2.9-6.5-6.5-6.5c-3.6,0-6.5,2.9-6.5,6.5v3.5h-2.4c-4.2,0-7.7,3.3-7.9,7.5 c-0.3,4.7-0.5,9.5-0.8,14.2c-0.3,5.9-4.1,11-9.6,13c-1,0.4-1.6,1.3-1.6,2.3v4c0,1.3,1.1,2.4,2.4,2.4H36c0,2.7,1.8,5.1,4.4,5.8v2.6 c0,0.9,0.7,1.6,1.6,1.6s1.6-0.7,1.6-1.6v-2.6c2.6-0.8,4.4-3.1,4.4-5.8h20.5c1.3,0,2.4-1.1,2.4-2.4v-4C70.9,56.3,70.3,55.4,69.3,55z M38.5,16.8c0-1.9,1.6-3.5,3.5-3.5s3.5,1.6,3.5,3.5v3.5h-7V16.8z"
}), /*#__PURE__*/createElement("path", {
  d: "M61,39.5l6.2-6.2c0.3-0.3,0.4-0.6,0.4-1c0-0.4-0.2-0.8-0.4-1c-0.3-0.3-0.6-0.4-1-0.4c0,0,0,0,0,0c-0.4,0-0.8,0.2-1,0.4 l-6.2,6.2l-6.2-6.2c-0.3-0.3-0.6-0.4-1-0.4c0,0,0,0,0,0c-0.4,0-0.8,0.2-1,0.4c-0.6,0.6-0.6,1.5,0,2l6.2,6.2l-6.2,6.2 c-0.6,0.6-0.6,1.5,0,2c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4l6.2-6.2l6.2,6.2c0.3,0.3,0.6,0.4,1,0.4c0.4,0,0.7-0.1,1-0.4 c0.3-0.3,0.4-0.6,0.4-1s-0.2-0.8-0.4-1L61,39.5z"
}));
const ClearAlarm = createSvg({
  name: 'clear_alarm',
  path: ClearAlarmGlyph
});

export default ClearAlarm;
export { ClearAlarmGlyph };
